"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8125],{

/***/ 25672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74229);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);




const HeroLead = (param)=>{
    let { className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__lead", className),
        ...props
    });
};
HeroLead.propTypes = {
    ..._Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroLead);


/***/ }),

/***/ 93816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72989);



/***/ }),

/***/ 48474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Resources; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 11 modules
var i18 = __webpack_require__(8610);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/createClient/index.js
var createClient = __webpack_require__(15959);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/ui/HeroBrand.js
var HeroBrand = __webpack_require__(68103);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Title.js
var Title = __webpack_require__(91319);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Lead.js
var Lead = __webpack_require__(25672);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Grid.js
var Grid = __webpack_require__(36432);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/TitleSection/Graphpad.js






const HeroTitleSectionGraphpad = (param)=>{
    let { title , description  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroRow */.P, {
        spacing: {
            mb: 10
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* HeroCol */.Z, {
            sm: 12,
            md: 9,
            sx: {
                textAlign: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                    sx: {
                        fontColor: "white"
                    },
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Lead/* default */.Z, {
                    children: description
                })
            ]
        })
    });
};
HeroTitleSectionGraphpad.propTypes = {
    title: prop_types.node,
    description: prop_types.node
};
/* harmony default export */ var Graphpad = (HeroTitleSectionGraphpad);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Description.js
var Description = __webpack_require__(50410);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var atomic_react_Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/TitleSection/Snapgene.js






const logo = "/images/common/new-snapgene-academy-logo-dark.png";
const HeroTitleSectionSnapgene = (param)=>{
    let { description  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Row */.X2, {
                center: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                    lg: 7,
                    sm: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: logo
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                children: description
            })
        ]
    });
};
HeroTitleSectionSnapgene.propTypes = {
    description: prop_types.node
};
/* harmony default export */ var Snapgene = (HeroTitleSectionSnapgene);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/TitleSection/Omiq.js





const HeroTitleSectionOmiq = (param)=>{
    let { title , description  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                spacing: {
                    mb: 12
                },
                children: description
            })
        ]
    });
};
HeroTitleSectionOmiq.propTypes = {
    title: prop_types.node,
    description: prop_types.node
};
/* harmony default export */ var Omiq = (HeroTitleSectionOmiq);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/TitleSection/Labarchives.js





const HeroTitleSectionLabarchives = (param)=>{
    let { title , description  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                children: description
            })
        ]
    });
};
HeroTitleSectionLabarchives.propTypes = {
    title: prop_types.node,
    description: prop_types.node
};
/* harmony default export */ var Labarchives = (HeroTitleSectionLabarchives);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/index.js + 1 modules
var PageNavbar = __webpack_require__(34246);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/Item.js
var Item = __webpack_require__(361);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/index.js + 6 modules
var Dropdown = __webpack_require__(38199);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/Menu.js
var Menu = __webpack_require__(36697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/MenuItem.js
var MenuItem = __webpack_require__(84586);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Inline/index.js + 1 modules
var Inline = __webpack_require__(31987);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/getContentProps.js
var getContentProps = __webpack_require__(76638);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/IconSection/Snapgene.js










const HeroIconSectionSnapgene = (param)=>{
    let { items =[]  } = param;
    return items.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavbar/* default */.Z, {
        alignHorizontal: "around",
        sticky: true,
        bgColor: "2",
        utility: {
            sm: {
                display: "none"
            },
            md: {
                display: "none"
            }
        },
        children: items.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                spacing: {
                    md: {
                        py: 3
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Title */.Z.Title, {
                            childrenProps: {
                                utility: {
                                    display: "flex",
                                    align: {
                                        items: "center"
                                    }
                                }
                            },
                            triangleProps: {
                                color: "white",
                                size: "xl"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inline/* default */.Z, {
                                sx: {
                                    fontColor: "white",
                                    fontSize: "l"
                                },
                                children: item.name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Body */.Z.Body, {
                            utility: {
                                bgColor: "transparent"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* default */.Z, {
                                shadow: false,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default.Link */.Z.Link, {
                                            className: "text-color-2 text-color-white--hover",
                                            href: "#".concat(item.id),
                                            children: "View All"
                                        })
                                    }, item.id),
                                    (item.items || []).map((subItem)=>{
                                        const { slug ="" , externalUrl =""  } = subItem;
                                        const contentProps = (0,getContentProps/* default */.Z)(subItem.sys_type, subItem.type);
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default.Link */.Z.Link, {
                                                className: "text-color-2 text-color-white--hover",
                                                href: contentProps && contentProps.alias ? "".concat(contentProps.alias, "/").concat(slug) : externalUrl,
                                                children: subItem.title
                                            })
                                        }, subItem.sys_id);
                                    })
                                ]
                            })
                        })
                    ]
                })
            }, item.id))
    });
};
HeroIconSectionSnapgene.propTypes = {
    items: (0,prop_types.arrayOf)((0,prop_types.shape)({
        blockOrder: prop_types.number,
        id: prop_types.string,
        name: prop_types.string,
        items: (0,prop_types.arrayOf)((0,prop_types.shape)({
            title: prop_types.string,
            url: prop_types.string,
            externalUrl: prop_types.string,
            slug: prop_types.string,
            type: prop_types.string,
            sys_id: prop_types.string
        }))
    }))
};
/* harmony default export */ var IconSection_Snapgene = (HeroIconSectionSnapgene);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 1 modules
var Icon = __webpack_require__(61672);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/IconSection/Omiq.js






const HeroIconSectionOmiq = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* HeroRow */.P, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroCol */.Z, {
                md: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                    href: "#getting-started",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            name: "rocket-launch",
                            size: "xxxxl"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                            sx: {
                                fontSize: "xl",
                                fontWeight: "bold"
                            },
                            children: "Getting Started"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroCol */.Z, {
                md: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                    href: "#learn-omiq",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            name: "graduation-cap",
                            size: "xxxxl"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                            sx: {
                                fontSize: "xl",
                                fontWeight: "bold"
                            },
                            children: "Learn OMIQ"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroCol */.Z, {
                md: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                    href: "https://help.omiq.ai/hc/en-us",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            name: "question",
                            size: "xxxxl"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                            sx: {
                                fontSize: "xl",
                                fontWeight: "bold"
                            },
                            children: "FAQ"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroCol */.Z, {
                md: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                    href: "https://help.omiq.ai/hc/en-us/requests/new?ticket_form_id=9319692139540",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            name: "comments-alt",
                            size: "xxxxl"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                            sx: {
                                fontSize: "xl",
                                fontWeight: "bold"
                            },
                            children: "Support"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var IconSection_Omiq = (HeroIconSectionOmiq);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/IconSection/Graphpad.js







const CardMini = (param)=>/*#__PURE__*/ {
    let { id , src , scrollTo , children  } = param;
    return (0,jsx_runtime.jsxs)(atomic_react_Grid/* Row */.X2, {
        py: true,
        className: "card-mini__image-block",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: "#".concat(id),
                    onClick: scrollTo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: src
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    sx: {
                        fontSize: "m"
                    },
                    spacing: {
                        mb: 0,
                        mt: "m7"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: "#".concat(id),
                        onClick: scrollTo,
                        color: "4",
                        hoverColor: "white",
                        children: children
                    })
                })
            })
        ]
    });
};
CardMini.propTypes = {
    id: prop_types.string.isRequired,
    src: prop_types.string.isRequired,
    children: prop_types.node.isRequired,
    scrollTo: prop_types.func.isRequired
};
const HeroIconSectionGraphpad = ()=>{
    const scrollToSection = (event)=>{
        event.preventDefault();
        const element = event.target;
        const isImg = element.tagName.toLowerCase() === "img";
        const href = isImg ? element.parentElement.getAttribute("href") : element.getAttribute("href");
        const id = href.substring(1, href.length);
        document.getElementById(id).scrollIntoView({
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Grid/* Row */.X2, {
        className: "medium-up-2 large-up-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                utility: {
                    align: {
                        self: "center"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardMini, {
                    scrollTo: scrollToSection,
                    id: "getting-started",
                    src: "/images/graphpad/resources/tutorials.svg",
                    children: [
                        "Getting Started ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " with Prism"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                utility: {
                    align: {
                        self: "center"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMini, {
                    scrollTo: scrollToSection,
                    id: "tutorials-guides",
                    src: "/images/graphpad/resources/guides.svg",
                    children: "Guides"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                utility: {
                    align: {
                        self: "center"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMini, {
                    scrollTo: scrollToSection,
                    id: "academy",
                    src: "/images/graphpad/resources/prism-acad-i.svg",
                    children: "Prism Academy"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                utility: {
                    align: {
                        self: "center"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardMini, {
                    scrollTo: scrollToSection,
                    id: "quick-calcs",
                    src: "/images/graphpad/resources/quickcalcs.svg",
                    children: "QuickCalcs"
                })
            })
        ]
    });
};
/* harmony default export */ var IconSection_Graphpad = (HeroIconSectionGraphpad);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/Link.js
var PageNavbar_Link = __webpack_require__(24661);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/IconSection/Labarchives.js





const HeroIconSectionLabarchives = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageNavbar/* default */.Z, {
        alignHorizontal: "around",
        bgColor: "",
        fullWidthBorder: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavbar_Link/* default */.Z, {
                    href: "#eln",
                    children: "ELN"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavbar_Link/* default */.Z, {
                    href: "#inventory",
                    children: "Inventory"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavbar_Link/* default */.Z, {
                    href: "#scheduler",
                    children: "Scheduler"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavbar_Link/* default */.Z, {
                    href: "#eln-for-education",
                    children: "ELN for Education"
                })
            })
        ]
    });
};
/* harmony default export */ var IconSection_Labarchives = (HeroIconSectionLabarchives);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/heroConfig.js
const heroConfig = {
    color: {
        sg: "black--02",
        gn: "transparent",
        gp: "gradient",
        om: "6",
        la: "4"
    },
    iconsInside: {
        sg: false,
        gn: true,
        gp: true,
        om: true,
        la: false
    }
};
/* harmony default export */ var SectionHero_heroConfig = (heroConfig);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/SectionHero.js













const brandHeroTitle = {
    sg: Snapgene,
    om: Omiq,
    gp: Graphpad,
    la: Labarchives
};
const brandHeroIcons = {
    sg: IconSection_Snapgene,
    om: IconSection_Omiq,
    gp: IconSection_Graphpad,
    la: IconSection_Labarchives
};
const SectionHero = (param)=>{
    let { title , description , brandCode , items =[]  } = param;
    const FactoryHeroTitleSection = brandHeroTitle[brandCode];
    const FactoryHeroIconSection = brandHeroIcons[brandCode];
    const iconsInside = SectionHero_heroConfig.iconsInside[brandCode];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroBrand/* default */.Z, {
                brandCode: brandCode,
                config: SectionHero_heroConfig,
                children: [
                    FactoryHeroTitleSection ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FactoryHeroTitleSection, {
                        title: title,
                        description: description
                    }) : null,
                    iconsInside && FactoryHeroIconSection ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FactoryHeroIconSection, {
                        items: items
                    }) : null
                ]
            }),
            !iconsInside && FactoryHeroIconSection ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FactoryHeroIconSection, {
                items: items
            }) : null
        ]
    });
};
SectionHero.propTypes = {
    title: prop_types.string.isRequired,
    description: prop_types.node.isRequired,
    brandCode: prop_types.string.isRequired,
    items: prop_types.array
};
/* harmony default export */ var SectionHero_SectionHero = (SectionHero);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionHero/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/FeaturedContentBlock/FeaturedContectItems.js
var FeaturedContectItems = __webpack_require__(65863);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(72989);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionResources/brand/Graphpad.js




const SectionResources = (param)=>{
    let { id , title , children , ...props } = param;
    const bgColor = id === "academy" ? "black--02" : "white";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default */.Z, {
        bgColor: bgColor,
        isBorderNone: true,
        id: id,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                children: title
            }) : null,
            children
        ]
    });
};
SectionResources.propTypes = {
    id: prop_types.string.isRequired,
    title: prop_types.string,
    children: prop_types.node
};
/* harmony default export */ var brand_Graphpad = (SectionResources);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionResources/brand/Default.js




const Default_SectionResources = (param)=>{
    let { id , title ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default */.Z, {
        bgColor: "white",
        id: id,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Title */.Z.Title, {
                children: title
            }) : null,
            children
        ]
    });
};
Default_SectionResources.propTypes = {
    id: prop_types.string.isRequired,
    title: prop_types.string,
    children: prop_types.node
};
/* harmony default export */ var Default = (Default_SectionResources);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/constants/index.js
var constants = __webpack_require__(34491);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionResources/SectionResources.js







const SectionResources_SectionResources = (param)=>{
    let { id , title , brandCode , Component =null , items =[] , ...props } = param;
    const SectionComponent = (brand)=>{
        switch(brand.toLowerCase()){
            case constants/* BRAND_CODE_GP */.yB:
                return brand_Graphpad;
            default:
                return Default;
        }
    };
    const itemsConfig = (brand)=>{
        switch(brand.toLowerCase()){
            case constants/* BRAND_CODE_OM */.h7:
            case constants/* BRAND_CODE_LA */.gf:
                return {
                    isImgFluid: true
                };
            default:
                return {
                    isImgFluid: false
                };
        }
    };
    const SectionBrand = SectionComponent(brandCode);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionBrand, {
        title: title,
        id: id,
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedContectItems/* default */.Z, {
                items: items,
                ...itemsConfig(brandCode)
            }),
            Component ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {}) : null
        ]
    });
};
SectionResources_SectionResources.propTypes = {
    brandCode: prop_types.string,
    id: prop_types.string.isRequired,
    title: prop_types.string,
    Component: prop_types.elementType,
    items: prop_types.array
};
/* harmony default export */ var components_SectionResources_SectionResources = (SectionResources_SectionResources);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/components/SectionResources/index.js


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/Page.js







const ResourcesPage = (param)=>{
    let { page , pageProps  } = param;
    const [t] = (0,i18/* useLocale */.bU)("resources");
    const { siteDomain , brandCode , customSections =[]  } = pageProps;
    const { sections  } = page;
    const list = [
        ...sections,
        ...customSections
    ];
    const sortSections = (a, b)=>{
        const sectionA = a.blockOrder;
        const sectionB = b.blockOrder;
        return sectionA < sectionB ? -1 : sectionA > sectionB ? 1 : 0; // eslint-disable-line
    };
    const listModified = (0,react.useMemo)(()=>list.sort(sortSections), [
        list,
        sortSections
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: t("META_TITLE"),
                description: t("META_DESCRIPTION"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        title: t("META_TITLE"),
                        description: t("META_DESCRIPTION"),
                        url: "".concat(siteDomain, "/resources")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                        card: t("META_TWITTER_CARD"),
                        site: t("META_TWITTER_SITE"),
                        creator: t("META_TWITTER_CREATOR"),
                        title: t("META_TITLE"),
                        description: t("META_DESCRIPTION")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: "".concat(siteDomain, "/resources")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHero_SectionHero, {
                title: t("TITLE"),
                description: t("DESCRIPTION"),
                brandCode: brandCode,
                items: listModified
            }),
            listModified.map((pageSection)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(components_SectionResources_SectionResources, {
                    id: pageSection.id,
                    brandCode: brandCode,
                    title: pageSection.name,
                    items: pageSection.items,
                    Component: pageSection.Component,
                    ...pageSection.props
                }, pageSection.id))
        ]
    });
};
ResourcesPage.propTypes = {
    page: prop_types.object.isRequired,
    pageProps: (0,prop_types.shape)({
        resources: prop_types.any,
        siteDomain: prop_types.string
    })
};
/* harmony default export */ var Page = (ResourcesPage);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/Apps/components/FeaturedContentBlock/mapper.js
var mapper = __webpack_require__(4830);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/locales/index.js
var locales = __webpack_require__(5235);
var locales_default = /*#__PURE__*/__webpack_require__.n(locales);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Resources/index.js







const contentfulResourcesFactory = (param)=>{
    let { Layout , contentfulProps , pageProps  } = param;
    const ContentfulResourcesPage = (param)=>{
        let { page  } = param;
        const { brandCode , resources =null  } = pageProps;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(i18/* LocaleProvider */.Iw, {
                resources: resources || (locales_default())[brandCode],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
                    page: page,
                    pageProps: pageProps
                })
            })
        });
    };
    ContentfulResourcesPage.getInitialProps = async ()=>{
        const client = (0,createClient/* default */.Z)(contentfulProps);
        const { filter ={}  } = contentfulProps;
        const blockFeaturedContent = await client.getEntries({
            content_type: "blockFeaturedContent",
            ...filter
        });
        return {
            page: {
                sections: (0,mapper/* default */.Z)(blockFeaturedContent)
            }
        };
    };
    ContentfulResourcesPage.propTypes = {
        ...Page.propTypes
    };
    return ContentfulResourcesPage;
};
/* harmony default export */ var Resources = (contentfulResourcesFactory);


/***/ }),

/***/ 34491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ub": function() { return /* binding */ RELEASE_NOTES_PER_PAGE; },
/* harmony export */   "_E": function() { return /* binding */ GUIDE_TYPES; },
/* harmony export */   "aU": function() { return /* binding */ BRAND_NAMES; },
/* harmony export */   "ec": function() { return /* binding */ BRAND_CODE_SG; },
/* harmony export */   "gf": function() { return /* binding */ BRAND_CODE_LA; },
/* harmony export */   "h7": function() { return /* binding */ BRAND_CODE_OM; },
/* harmony export */   "lc": function() { return /* binding */ PUBLISHED; },
/* harmony export */   "yB": function() { return /* binding */ BRAND_CODE_GP; }
/* harmony export */ });
/* unused harmony exports BLOGS_PER_PAGE, BRAND_CODE_GN */
const RELEASE_NOTES_PER_PAGE = 20;
const BLOGS_PER_PAGE = 12;
const BRAND_CODE_GP = "gp";
const BRAND_CODE_SG = "sg";
const BRAND_CODE_GN = "gn";
const BRAND_CODE_OM = "om";
const BRAND_CODE_LA = "la";
const PUBLISHED = "Live";
const GUIDE_TYPES = {
    Guide: "guide",
    Tutorial: "tutorial"
};
const BRAND_NAMES = {
    om: "OMIQ",
    sg: "Snapgene",
    gp: "Graphpad",
    gn: "Geneious",
    la: "LabArchives"
};


/***/ }),

/***/ 68103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _insightfulscience_atomic_react_Hero__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69591);




const HeroBrand = (param)=>{
    let { brandCode ="sg" , config , children , ...props } = param;
    const { color  } = config;
    const brandColor = (brand)=>color[brand];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Hero__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        color: brandColor(brandCode),
        ...props,
        children: children
    });
};
HeroBrand.propTypes = {
    brandCode: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "sg",
        "gp",
        "gn",
        "om",
        "la"
    ]),
    config: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.shape)({
        color: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.shape)({
            gn: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            sg: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            gp: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            om: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            la: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
        })
    }),
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroBrand);


/***/ })

}]);